import {EndoMultiToothExamCavityDataModel} from './endo-multi-tooth-exam-cavity-data.model';
import {EndoMultiToothExamSurfaceDataModel} from './endo-multi-tooth-exam-surface-data.model';

export class EndoMultiToothExamToothDataModel {
  MTEToothID: string = '';
  ToothId: string = '';
  enumMTEChiefComplaintID: string = '';
  enumMTEPalpationID: string = '';
  enumMTEPercussionID: string = '';
  enumMTEMobilityID: string = '';
  enumMTEChewingID: string = '';
  enumMTEBiteID: string = '';
  enumMTEAirID: string = '';
  enumMTEColdID: string = '';
  isCavity: boolean;
  enumMTEHotID: string = '';
  enumMTEeptID: string = '';
  enumMTESinusTrackID: string = '';
  enumMTEOccusalTraumaID: string = '';
  enumMTEFractureID: string = '';
  enumMTEPulpDiagID: string = '';
  enumMTEPerDiagID: string = '';
  enumMTEEndoPrognosisID: string = '';
  enumMTEPerioPrognosisID: string = '';
  enumMTERestorPrognosisID: string = '';
  enumMTERecomendedTxID: string = '';
  enumMTERecomendedTx_AfterID: string = '';
  enumMTERecomendedTx_ThirdID: string = '';
  enumMTETretmentOrderID: string = '';
  enumMTENumberOfVisitsID: string = '';
  enumMTEVitalTestCavityID: string = '';
  enumMTESweetsID: string = '';
  enumMTEFlossingID: string = '';
  enumMTELayingDownID: string = '';
  enumMTEExersiseBPID: string = '';
  enumMTEHeadPosistionID: string = '';
  enumMTECervicalSensID: string = '';
  enumMTEBLateralForceID: string = '';
  enumMTELLateralForceID: string = '';
  isToothDownloaded: boolean;
  dataEndoMutiToothExamTeethCavities: EndoMultiToothExamCavityDataModel[] = [];
  dataEndoMutiToothExamSurfaces: EndoMultiToothExamSurfaceDataModel[] = [];
}
